/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateConversationRequest
 */
export interface CreateConversationRequest {
    /**
     * 
     * @type {number}
     * @memberof CreateConversationRequest
     */
    claimId?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateConversationRequest
     */
    title?: string;
}

/**
 * Check if a given object implements the CreateConversationRequest interface.
 */
export function instanceOfCreateConversationRequest(value: object): value is CreateConversationRequest {
    return true;
}

export function CreateConversationRequestFromJSON(json: any): CreateConversationRequest {
    return CreateConversationRequestFromJSONTyped(json, false);
}

export function CreateConversationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateConversationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'claimId': json['claimId'] == null ? undefined : json['claimId'],
        'title': json['title'] == null ? undefined : json['title'],
    };
}

export function CreateConversationRequestToJSON(json: any): CreateConversationRequest {
    return CreateConversationRequestToJSONTyped(json, false);
}

export function CreateConversationRequestToJSONTyped(value?: CreateConversationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimId': value['claimId'],
        'title': value['title'],
    };
}

